"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ClinicBranding/ClinicContactCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _urls = require('web/services/urls');

var _clinicContactRows = require('shared/services/clinicContactRows');


/* The clinic's contact card (D-11, mockups/iphone-full-card.png): its logo
 * on a white plate (or square icon), its name, a row for each field it
 * filled in, then the grey line offering BloomText support for technical
 * problems. The secure link shows it in a sheet or popover; the branding
 * settings page shows it in its preview. Colours come from the page's
 * --accent tokens, so a branded page tints the row icons. */

const ROW_ICONS = {
  call: 'call',
  email: 'mail',
  website: 'language',
  address: 'place',
  directions: 'directions',
}








const ClinicMark = ({ clinic }) => {
  const [failed, setFailed] = _react.useState(null)
  const src = clinic.LogoURL || clinic.IconURL
  if (!src || failed === src) return null
  return (
    _react2.default.createElement('div', { className: clinic.LogoURL ? 'clinic-card--logo' : 'clinic-card--icon', __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
      , _react2.default.createElement('img', { src: src, alt: _nullishCoalesce(clinic.Name, () => ( '')), onError: () => setFailed(src), __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
    )
  )
}

const ClinicContactCard = ({ clinic, headingId, onClose }) => {
  const rows = clinic.Contact ? _clinicContactRows.contactRows.call(void 0, clinic.Contact) : []
  return (
    _react2.default.createElement('div', { className: "clinic-card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      , _react2.default.createElement('div', { className: "clinic-card--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        , _react2.default.createElement('div', { className: "clinic-card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
          , _react2.default.createElement(ClinicMark, { clinic: clinic, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} )
          , _react2.default.createElement('h2', { id: headingId, className: "clinic-card--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  clinic.Name )
          , _react2.default.createElement('p', { className: "clinic-card--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Contact the clinic directly"   )
        )
        ,  onClose && (
          _react2.default.createElement('button', { type: "button", className: "clinic-card--close", 'aria-label': "Close", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "close")
          )
        )
      )
      ,  rows.length > 0 && (
        _react2.default.createElement('ul', { className: "clinic-card--rows", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          ,  rows.map(row => {
            const content = (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('span', { className: "clinic-card--row-icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
                  , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}},  ROW_ICONS[row.kind] )
                )
                , _react2.default.createElement('span', { className: "clinic-card--row-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
                  , _react2.default.createElement('span', { className: "clinic-card--row-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}},  row.label )
                  , _react2.default.createElement('span', { className: "clinic-card--row-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}},  row.value )
                )
                ,  row.href && (
                  _react2.default.createElement('i', { className: "material-icons clinic-card--row-go" , 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
                    ,  row.external ? 'open_in_new' : 'chevron_right' 
                  )
                )
              )
            )
            return (
              _react2.default.createElement('li', { key: row.kind, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
                ,  row.href
                  ? (
                      _react2.default.createElement('a', {
                        className: "clinic-card--row",
                        href: row.href,
                        ...(row.external && { target: '_blank', rel: 'noopener noreferrer' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}

                        ,  content 
                      )
                    )
                  : _react2.default.createElement('div', { className: "clinic-card--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  content ) 
              )
            )
          })
        )
      )
      , _react2.default.createElement('p', { className: "clinic-card--support", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, "Technical problem with this page?"

        , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 96}} )
        , _react2.default.createElement('a', { href: _urls.supportUrl, target: "_blank", rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "Contact BloomText support"  )
      )
    )
  )
}

exports. default = ClinicContactCard
